
import { AOTCharacter } from './types';

// Attack on Titan Character Database
export const AOT_CHARACTERS: AOTCharacter[] = [
    // ============ MAIN CHARACTERS ============
    {
        id: '1',
        name: 'Eren Yeager',
        gender: 'Male',
        arc: 'Fall of Shiganshina',
        arcNumber: 1,
        affiliation: 'Scout Regiment',
        species: 'Titan Shifter',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "I'll keep moving forward... until I destroy my enemies.",
            tr: "İlerleyeceğim... düşmanlarımı yok edene kadar.",
            es: "Seguiré adelante... hasta destruir a mis enemigos."
        },
        image: '/images/eren_yeager.webp',
        hasVerifiedQuote: true
    },
    {
        id: '2',
        name: 'Mikasa Ackerman',
        gender: 'Female',
        arc: 'Fall of Shiganshina',
        arcNumber: 1,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Average',
        status: 'Alive',
        quotes: {
            en: "If I can't, then I'll just die. But if I win, I live. Unless I fight, I cannot win.",
            tr: "Eğer yapamazsam, o zaman ölürüm. Ama kazanırsam, yaşarım. Savaşmazsam, kazanamam.",
            es: "Si no puedo, moriré. Pero si gano, vivo. Si no lucho, no puedo ganar."
        },
        image: '/images/mikasa_ackerman.webp',
        hasVerifiedQuote: true
    },
    {
        id: '3',
        name: 'Armin Arlert',
        gender: 'Male',
        arc: 'Fall of Shiganshina',
        arcNumber: 1,
        affiliation: 'Scout Regiment',
        species: 'Titan Shifter',
        height: 'Short',
        status: 'Alive',
        quotes: {
            en: "Someone who can't sacrifice anything, can't ever change anything.",
            tr: "Hiçbir şey feda edemeyen biri, hiçbir şeyi değiştiremez.",
            es: "Alguien que no puede sacrificar nada, no puede cambiar nada."
        },
        image: '/images/armin_arlert.webp',
        hasVerifiedQuote: true
    },
    {
        id: '4',
        name: 'Levi Ackerman',
        gender: 'Male',
        arc: 'Female Titan',
        arcNumber: 4,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Short',
        status: 'Alive',
        quotes: {
            en: "Give up on your dreams and die. Lead the recruits straight into hell.",
            tr: "Hayallerinden vazgeç ve öl. Acemileri doğrudan cehenneme götür.",
            es: "Renuncia a tus sueños y muere. Lleva a los reclutas directo al infierno."
        },
        image: '/images/levi_ackerman.webp',
        hasVerifiedQuote: true
    },
    {
        id: '5',
        name: 'Erwin Smith',
        gender: 'Male',
        arc: 'Trost',
        arcNumber: 3,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "Shinzou wo Sasageyo! Dedicate your hearts!",
            tr: "Kalbinizi adayın! Shinzou wo Sasageyo!",
            es: "¡Shinzou wo Sasageyo! ¡Entreguen sus corazones!"
        },
        image: '/images/erwin_smith.webp',
        hasVerifiedQuote: true
    },
    {
        id: '6',
        name: 'Hange Zoë',
        gender: 'Female',
        arc: 'Trost',
        arcNumber: 3,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "Good morning! Did you know Titans don't need to sleep?",
            tr: "Günaydın! Titanların uyumaya ihtiyacı olmadığını biliyor muydun?",
            es: "¡Buenos días! ¿Sabías que los Titanes no necesitan dormir?"
        },
        image: '/images/hange_zo.webp',
        hasVerifiedQuote: true
    },
    {
        id: '7',
        name: 'Jean Kirstein',
        gender: 'Male',
        arc: 'Training',
        arcNumber: 2,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Tall',
        status: 'Alive',
        quotes: {
            en: "I want to live a safe life within the walls.",
            tr: "Duvarların içinde güvenli bir hayat yaşamak istiyorum.",
            es: "Quiero vivir una vida segura dentro de los muros."
        },
        image: '/images/jean_kirstein.webp',
        hasVerifiedQuote: true
    },
    {
        id: '8',
        name: 'Connie Springer',
        gender: 'Male',
        arc: 'Training',
        arcNumber: 2,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Short',
        status: 'Alive',
        quotes: {
            en: "We're comrades, aren't we?",
            tr: "Biz yoldaşız, değil mi?",
            es: "Somos camaradas, ¿no?"
        },
        image: '/images/connie_springer.webp',
        hasVerifiedQuote: true
    },
    {
        id: '9',
        name: 'Sasha Blouse',
        gender: 'Female',
        arc: 'Training',
        arcNumber: 2,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "Meat! That's meat!",
            tr: "Et! Bu et!",
            es: "¡Carne! ¡Eso es carne!"
        },
        image: '/images/sasha_blouse.webp',
        hasVerifiedQuote: true
    },
    {
        id: '10',
        name: 'Historia Reiss',
        gender: 'Female',
        arc: 'Training',
        arcNumber: 2,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Short',
        status: 'Alive',
        quotes: {
            en: "I'm the worst girl who ever lived.",
            tr: "Ben yaşamış en kötü kızım.",
            es: "Soy la peor chica que haya existido."
        },
        image: '/images/historia_reiss.webp',
        hasVerifiedQuote: true
    },
    {
        id: '11',
        name: 'Ymir',
        gender: 'Female',
        arc: 'Clash of Titans',
        arcNumber: 5,
        affiliation: 'Scout Regiment',
        species: 'Titan Shifter',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "I have no right to tell you how to live. So do whatever you want.",
            tr: "Nasıl yaşayacağını söyleme hakkım yok. Yani ne istersen onu yap.",
            es: "No tengo derecho a decirte cómo vivir. Así que haz lo que quieras."
        },
        image: '/images/ymir.webp',
        hasVerifiedQuote: true
    },
    {
        id: '12',
        name: 'Reiner Braun',
        gender: 'Male',
        arc: 'Training',
        arcNumber: 2,
        affiliation: 'Warriors',
        species: 'Titan Shifter',
        height: 'Tall',
        status: 'Alive',
        quotes: {
            en: "I'm the Armored Titan, and he's the Colossal Titan.",
            tr: "Ben Zırhlı Titan'ım, o da Devasa Titan.",
            es: "Yo soy el Titán Acorazado, y él es el Titán Colosal."
        },
        image: '/images/reiner_braun.webp',
        hasVerifiedQuote: true
    },
    {
        id: '13',
        name: 'Bertholdt Hoover',
        gender: 'Male',
        arc: 'Training',
        arcNumber: 2,
        affiliation: 'Warriors',
        species: 'Titan Shifter',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "Someone has to do it... Someone has to get their hands dirty.",
            tr: "Birisi bunu yapmalı... Birisi ellerini kirletmeli.",
            es: "Alguien tiene que hacerlo... Alguien tiene que ensuciarse las manos."
        },
        image: '/images/bertholdt_hoover.webp',
        hasVerifiedQuote: true
    },
    {
        id: '14',
        name: 'Annie Leonhart',
        gender: 'Female',
        arc: 'Training',
        arcNumber: 2,
        affiliation: 'Warriors',
        species: 'Titan Shifter',
        height: 'Short',
        status: 'Alive',
        quotes: {
            en: "I just want the weak, who get swept along with the flow, to be considered human too.",
            tr: "Sadece akıntıyla sürüklenen zayıfların da insan olarak kabul edilmesini istiyorum.",
            es: "Solo quiero que los débiles, que son arrastrados por la corriente, también sean considerados humanos."
        },
        image: '/images/annie_leonhart.webp',
        hasVerifiedQuote: true
    },
    {
        id: '15',
        name: 'Marco Bodt',
        gender: 'Male',
        arc: 'Trost',
        arcNumber: 3,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "I think you're weak. That's why you can understand how the weak feel.",
            tr: "Bence sen zayıfsın. Bu yüzden zayıfların nasıl hissettiğini anlayabiliyorsun.",
            es: "Creo que eres débil. Por eso puedes entender cómo se sienten los débiles."
        },
        image: '/images/marco_bodt.webp',
        hasVerifiedQuote: true
    },
    // ============ SCOUT REGIMENT ============
    {
        id: '16',
        name: 'Keith Shadis',
        gender: 'Male',
        arc: 'Training',
        arcNumber: 2,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "You are the worst recruits I've ever seen!",
            tr: "Gördüğüm en kötü acemisiniz!",
            es: "¡Son los peores reclutas que he visto!"
        },
        image: '/images/keith_shadis.webp',
        hasVerifiedQuote: true
    },
    {
        id: '17',
        name: 'Petra Ral',
        gender: 'Female',
        arc: 'Female Titan',
        arcNumber: 4,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Short',
        status: 'Deceased',
        quotes: {
            en: "Trust in us, Captain Levi!",
            tr: "Bize güvenin, Kaptan Levi!",
            es: "¡Confía en nosotros, Capitán Levi!"
        },
        image: '/images/petra_ral.webp',
        hasVerifiedQuote: true
    },
    {
        id: '18',
        name: 'Oluo Bozad',
        gender: 'Male',
        arc: 'Female Titan',
        arcNumber: 4,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "Brats like you don't understand anything.",
            tr: "Senin gibi veletler hiçbir şey anlamaz.",
            es: "Mocosos como tú no entienden nada."
        },
        image: '/images/oluo_bozad.webp',
        hasVerifiedQuote: true
    },
    {
        id: '19',
        name: 'Eld Jinn',
        gender: 'Male',
        arc: 'Female Titan',
        arcNumber: 4,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "We'll take care of this!",
            tr: "Bunu biz halledeceğiz!",
            es: "¡Nosotros nos encargamos de esto!"
        },
        image: '/images/eld_jinn.webp',
        hasVerifiedQuote: true
    },
    {
        id: '20',
        name: 'Gunther Schultz',
        gender: 'Male',
        arc: 'Female Titan',
        arcNumber: 4,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "Form up! Protect Eren!",
            tr: "Düzen alın! Eren'i koruyun!",
            es: "¡Formación! ¡Protejan a Eren!"
        },
        image: '/images/gunther_schultz.webp',
        hasVerifiedQuote: true
    },
    {
        id: '21',
        name: 'Mike Zacharias',
        gender: 'Male',
        arc: 'Female Titan',
        arcNumber: 4,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "*sniffs* ...Interesting.",
            tr: "*koklar* ...İlginç.",
            es: "*olfatea* ...Interesante."
        },
        image: '/images/mike_zacharias.webp',
        hasVerifiedQuote: true
    },
    {
        id: '22',
        name: 'Nanaba',
        gender: 'Female',
        arc: 'Clash of Titans',
        arcNumber: 5,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "Don't let them climb the walls!",
            tr: "Duvarlara tırmanmalarına izin vermeyin!",
            es: "¡No dejen que escalen los muros!"
        },
        image: '/images/nanaba.webp',
        hasVerifiedQuote: true
    },
    {
        id: '23',
        name: 'Moblit Berner',
        gender: 'Male',
        arc: 'Clash of Titans',
        arcNumber: 5,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "Section Commander, please be careful!",
            tr: "Bölüm Komutanı, lütfen dikkatli olun!",
            es: "¡Comandante de Sección, por favor tenga cuidado!"
        },
        image: '/images/moblit_berner.webp',
        hasVerifiedQuote: true
    },
    {
        id: '24',
        name: 'Floch Forster',
        gender: 'Male',
        arc: 'Return to Shiganshina',
        arcNumber: 7,
        affiliation: 'Yeagerists',
        species: 'Human',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "Dedicate your hearts! For Eldia!",
            tr: "Kalbinizi adayın! Eldia için!",
            es: "¡Entreguen sus corazones! ¡Por Eldia!"
        },
        image: '/images/floch_forster.webp',
        hasVerifiedQuote: true
    },
    {
        id: '25',
        name: 'Marlo Freudenberg',
        gender: 'Male',
        arc: 'Uprising',
        arcNumber: 6,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "I want to fix things from the inside!",
            tr: "İçeriden düzeltmek istiyorum!",
            es: "¡Quiero arreglar las cosas desde adentro!"
        },
        image: '/images/marlo_freudenberg.webp',
        hasVerifiedQuote: true
    },
    {
        id: '26',
        name: 'Hitch Dreyse',
        gender: 'Female',
        arc: 'Uprising',
        arcNumber: 6,
        affiliation: 'Military Police',
        species: 'Human',
        height: 'Average',
        status: 'Alive',
        quotes: {
            en: "What's so great about the Military Police anyway?",
            tr: "Askeri Polis'in nesi bu kadar harika ki?",
            es: "¿Qué tiene de genial la Policía Militar de todos modos?"
        },
        image: '/images/hitch_dreyse.webp',
        hasVerifiedQuote: true
    },
    // ============ ROYAL FAMILY & UPRISING ============
    {
        id: '27',
        name: 'Rod Reiss',
        gender: 'Male',
        arc: 'Uprising',
        arcNumber: 6,
        affiliation: 'Civilians',
        species: 'Human',
        height: 'Short',
        status: 'Deceased',
        quotes: {
            en: "Historia, you must become a Titan.",
            tr: "Historia, Titan olmalısın.",
            es: "Historia, debes convertirte en un Titán."
        },
        image: '/images/rod_reiss.webp',
        hasVerifiedQuote: true
    },
    {
        id: '28',
        name: 'Frieda Reiss',
        gender: 'Female',
        arc: 'Uprising',
        arcNumber: 6,
        affiliation: 'Civilians',
        species: 'Titan Shifter',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "You're not like other girls, Historia. You're special.",
            tr: "Sen diğer kızlar gibi değilsin, Historia. Özelsin.",
            es: "No eres como las otras chicas, Historia. Eres especial."
        },
        image: '/images/frieda_reiss.webp',
        hasVerifiedQuote: true
    },
    {
        id: '29',
        name: 'Kenny Ackerman',
        gender: 'Male',
        arc: 'Uprising',
        arcNumber: 6,
        affiliation: 'Military Police',
        species: 'Human',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "Everyone had to be drunk on something to keep pushing on.",
            tr: "Herkes devam edebilmek için bir şeye sarhoş olmalıydı.",
            es: "Todos tenían que estar ebrios de algo para seguir adelante."
        },
        image: '/images/kenny_ackerman.webp',
        hasVerifiedQuote: true
    },
    // ============ GARRISON & MILITARY POLICE ============
    {
        id: '30',
        name: 'Dot Pixis',
        gender: 'Male',
        arc: 'Trost',
        arcNumber: 3,
        affiliation: 'Garrison',
        species: 'Human',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "I would not mind being eaten, if it were by a beautiful lady Titan.",
            tr: "Yenilmeyi umursamazdım, eğer güzel bir bayan Titan tarafından olsaydı.",
            es: "No me importaría ser devorado, si fuera por una hermosa Titán."
        },
        image: '/images/dot_pixis.webp',
        hasVerifiedQuote: true
    },
    {
        id: '31',
        name: 'Rico Brzenska',
        gender: 'Female',
        arc: 'Trost',
        arcNumber: 3,
        affiliation: 'Garrison',
        species: 'Human',
        height: 'Short',
        status: 'Alive',
        quotes: {
            en: "Humanity needed a victory.",
            tr: "İnsanlığın bir zafere ihtiyacı vardı.",
            es: "La humanidad necesitaba una victoria."
        },
        image: '/images/rico_brzenska.webp',
        hasVerifiedQuote: true
    },
    {
        id: '32',
        name: 'Hannes',
        gender: 'Male',
        arc: 'Fall of Shiganshina',
        arcNumber: 1,
        affiliation: 'Garrison',
        species: 'Human',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "Next time, I'll definitely save you!",
            tr: "Bir dahaki sefere, seni kesinlikle kurtaracağım!",
            es: "¡La próxima vez, definitivamente te salvaré!"
        },
        image: '/images/hannes.webp',
        hasVerifiedQuote: true
    },
    {
        id: '33',
        name: 'Nile Dok',
        gender: 'Male',
        arc: 'Female Titan',
        arcNumber: 4,
        affiliation: 'Military Police',
        species: 'Human',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "The Military Police exist to maintain order.",
            tr: "Askeri Polis düzeni korumak için var.",
            es: "La Policía Militar existe para mantener el orden."
        },
        image: '/images/nile_dok.webp',
        hasVerifiedQuote: true
    },
    // ============ YEAGER FAMILY ============
    {
        id: '34',
        name: 'Grisha Yeager',
        gender: 'Male',
        arc: 'Fall of Shiganshina',
        arcNumber: 1,
        affiliation: 'Civilians',
        species: 'Titan Shifter',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "This key will lead you to the truth.",
            tr: "Bu anahtar seni gerçeğe götürecek.",
            es: "Esta llave te llevará a la verdad."
        },
        image: '/images/grisha_yeager.webp',
        hasVerifiedQuote: true
    },
    {
        id: '35',
        name: 'Carla Yeager',
        gender: 'Female',
        arc: 'Fall of Shiganshina',
        arcNumber: 1,
        affiliation: 'Civilians',
        species: 'Human',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "He doesn't need to be great. He's already special because he was born into this world.",
            tr: "Harika olmak zorunda değil. Bu dünyaya doğduğu için zaten özel.",
            es: "No necesita ser grandioso. Ya es especial porque nació en este mundo."
        },
        image: '/images/carla_yeager.webp',
        hasVerifiedQuote: true
    },
    {
        id: '36',
        name: 'Dina Fritz',
        gender: 'Female',
        arc: 'Clash of Titans',
        arcNumber: 5,
        affiliation: 'Civilians',
        species: 'Human',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "I will find you, Grisha. No matter what form I take.",
            tr: "Seni bulacağım, Grisha. Ne form alırsam alayım.",
            es: "Te encontraré, Grisha. Sin importar qué forma tome."
        },
        image: '/images/dina_fritz.webp',
        hasVerifiedQuote: true
    },
    // ============ MARLEY CHARACTERS ============
    {
        id: '37',
        name: 'Zeke Yeager',
        gender: 'Male',
        arc: 'Clash of Titans',
        arcNumber: 5,
        affiliation: 'Warriors',
        species: 'Titan Shifter',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "There's no need for this world to be cruel.",
            tr: "Bu dünyanın acımasız olmasına gerek yok.",
            es: "No hay necesidad de que este mundo sea cruel."
        },
        image: '/images/zeke_yeager.webp',
        hasVerifiedQuote: true
    },
    {
        id: '38',
        name: 'Pieck Finger',
        gender: 'Female',
        arc: 'Marley',
        arcNumber: 8,
        affiliation: 'Warriors',
        species: 'Titan Shifter',
        height: 'Average',
        status: 'Alive',
        quotes: {
            en: "As expected of Pieck! That's exactly right!",
            tr: "Pieck'ten beklendiği gibi! Tam olarak doğru!",
            es: "¡Como se esperaba de Pieck! ¡Exactamente correcto!"
        },
        image: '/images/pieck_finger.webp',
        hasVerifiedQuote: true
    },
    {
        id: '39',
        name: 'Porco Galliard',
        gender: 'Male',
        arc: 'Marley',
        arcNumber: 8,
        affiliation: 'Warriors',
        species: 'Titan Shifter',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "You're not fit to inherit the Armored Titan!",
            tr: "Zırhlı Titan'ı miras almaya layık değilsin!",
            es: "¡No eres digno de heredar el Titán Acorazado!"
        },
        image: '/images/porco_galliard.webp',
        hasVerifiedQuote: true
    },
    {
        id: '40',
        name: 'Colt Grice',
        gender: 'Male',
        arc: 'Marley',
        arcNumber: 8,
        affiliation: 'Warriors',
        species: 'Human',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "Falco, run!",
            tr: "Falco, kaç!",
            es: "¡Falco, corre!"
        },
        image: '/images/colt_grice.webp',
        hasVerifiedQuote: true
    },
    {
        id: '41',
        name: 'Falco Grice',
        gender: 'Male',
        arc: 'Marley',
        arcNumber: 8,
        affiliation: 'Warriors',
        species: 'Titan Shifter',
        height: 'Short',
        status: 'Alive',
        quotes: {
            en: "I want to save Gabi... and everyone.",
            tr: "Gabi'yi... ve herkesi kurtarmak istiyorum.",
            es: "Quiero salvar a Gabi... y a todos."
        },
        image: '/images/falco_grice.webp',
        hasVerifiedQuote: true
    },
    {
        id: '42',
        name: 'Gabi Braun',
        gender: 'Female',
        arc: 'Marley',
        arcNumber: 8,
        affiliation: 'Warriors',
        species: 'Human',
        height: 'Short',
        status: 'Alive',
        quotes: {
            en: "I'm going to kill every last one of them!",
            tr: "Hepsini öldüreceğim!",
            es: "¡Voy a matar a cada uno de ellos!"
        },
        image: '/images/gabi_braun.webp',
        hasVerifiedQuote: true
    },
    {
        id: '43',
        name: 'Theo Magath',
        gender: 'Male',
        arc: 'Marley',
        arcNumber: 8,
        affiliation: 'Marleyan Military',
        species: 'Human',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "These kids are weapons. Nothing more.",
            tr: "Bu çocuklar silahtır. Başka bir şey değil.",
            es: "Estos niños son armas. Nada más."
        },
        image: '/images/theo_magath.webp',
        hasVerifiedQuote: true
    },
    {
        id: '44',
        name: 'Udo',
        gender: 'Male',
        arc: 'Marley',
        arcNumber: 8,
        affiliation: 'Warriors',
        species: 'Human',
        height: 'Short',
        status: 'Deceased',
        quotes: {
            en: "Outside of Marley, Eldians are treated even worse!",
            tr: "Marley'in dışında, Eldialılara daha kötü davranılıyor!",
            es: "¡Fuera de Marley, los Eldianos son tratados aún peor!"
        },
        image: '/images/udo.webp',
        hasVerifiedQuote: true
    },
    {
        id: '45',
        name: 'Zofia',
        gender: 'Female',
        arc: 'Marley',
        arcNumber: 8,
        affiliation: 'Warriors',
        species: 'Human',
        height: 'Short',
        status: 'Deceased',
        quotes: {
            en: "I bet I can eat more than you!",
            tr: "Bahse girerim senden fazla yiyebilirim!",
            es: "¡Apuesto a que puedo comer más que tú!"
        },
        image: '/images/zofia.webp',
        hasVerifiedQuote: true
    },
    {
        id: '46',
        name: 'Marcel Galliard',
        gender: 'Male',
        arc: 'Marley',
        arcNumber: 8,
        affiliation: 'Warriors',
        species: 'Titan Shifter',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "I rigged the selection so Reiner would be chosen...",
            tr: "Reiner'ın seçilmesi için seçimi ayarladım...",
            es: "Manipulé la selección para que eligieran a Reiner..."
        },
        image: '/images/marcel_galliard.webp',
        hasVerifiedQuote: true
    },
    {
        id: '47',
        name: 'Tom Ksaver',
        gender: 'Male',
        arc: 'War for Paradis',
        arcNumber: 9,
        affiliation: 'Warriors',
        species: 'Titan Shifter',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "Zeke, you saved me.",
            tr: "Zeke, sen beni kurtardın.",
            es: "Zeke, tú me salvaste."
        },
        image: '/images/tom_ksaver.webp',
        hasVerifiedQuote: true
    },
    // ============ ANTI-MARLEYAN VOLUNTEERS ============
    {
        id: '48',
        name: 'Yelena',
        gender: 'Female',
        arc: 'Marley',
        arcNumber: 8,
        affiliation: 'Yeagerists',
        species: 'Human',
        height: 'Tall',
        status: 'Alive',
        quotes: {
            en: "I've devoted myself to Zeke's plan.",
            tr: "Kendimi Zeke'in planına adadım.",
            es: "Me he dedicado al plan de Zeke."
        },
        image: '/images/yelena.webp',
        hasVerifiedQuote: true
    },
    {
        id: '49',
        name: 'Onyankopon',
        gender: 'Male',
        arc: 'Marley',
        arcNumber: 8,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Tall',
        status: 'Alive',
        quotes: {
            en: "God wanted us to be diverse.",
            tr: "Tanrı farklı olmamızı istedi.",
            es: "Dios quiso que fuéramos diversos."
        },
        image: '/images/onyankopon.webp',
        hasVerifiedQuote: true
    },
    {
        id: '50',
        name: 'Nicolo',
        gender: 'Male',
        arc: 'War for Paradis',
        arcNumber: 9,
        affiliation: 'Civilians',
        species: 'Human',
        height: 'Average',
        status: 'Alive',
        quotes: {
            en: "Sasha... she loved my cooking.",
            tr: "Sasha... yemeklerimi severdi.",
            es: "Sasha... amaba mi cocina."
        },
        image: '/images/nicolo.webp',
        hasVerifiedQuote: true
    },
    // ============ TYBUR FAMILY ============
    {
        id: '51',
        name: 'Willy Tybur',
        gender: 'Male',
        arc: 'Marley',
        arcNumber: 8,
        affiliation: 'Civilians',
        species: 'Human',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "The true enemy of the world... is Eren Yeager!",
            tr: "Dünyanın gerçek düşmanı... Eren Yeager!",
            es: "¡El verdadero enemigo del mundo... es Eren Yeager!"
        },
        image: '/images/willy_tybur.webp',
        hasVerifiedQuote: true
    },
    {
        id: '52',
        name: 'Lara Tybur',
        gender: 'Female',
        arc: 'Marley',
        arcNumber: 8,
        affiliation: 'Civilians',
        species: 'Titan Shifter',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "I will protect my brother.",
            tr: "Kardeşimi koruyacağım.",
            es: "Protegeré a mi hermano."
        },
        image: '/images/lara_tybur.webp',
        hasVerifiedQuote: true
    },
    // ============ HISTORICAL / FOUNDER ============
    {
        id: '53',
        name: 'Ymir Fritz',
        gender: 'Female',
        arc: 'War for Paradis',
        arcNumber: 9,
        affiliation: 'Civilians',
        species: 'Titan Shifter',
        height: 'Short',
        status: 'Deceased',
        quotes: {
            en: "...",
            tr: "...",
            es: "..."
        },
        image: '/images/ymir_fritz.webp',
        hasVerifiedQuote: false
    },
    {
        id: '54',
        name: 'Eren Kruger',
        gender: 'Male',
        arc: 'Return to Shiganshina',
        arcNumber: 7,
        affiliation: 'Civilians',
        species: 'Titan Shifter',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "If you want to save Mikasa and Armin... you must complete this mission.",
            tr: "Mikasa ve Armin'i kurtarmak istiyorsan... bu görevi tamamlamalısın.",
            es: "Si quieres salvar a Mikasa y Armin... debes completar esta misión."
        },
        image: '/images/eren_kruger.webp',
        hasVerifiedQuote: true
    },
    {
        id: '55',
        name: 'Uri Reiss',
        gender: 'Male',
        arc: 'Uprising',
        arcNumber: 6,
        affiliation: 'Civilians',
        species: 'Titan Shifter',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "I'm sorry, Kenny. For the sins of my ancestors.",
            tr: "Özür dilerim, Kenny. Atalarımın günahları için.",
            es: "Lo siento, Kenny. Por los pecados de mis ancestros."
        },
        image: '/images/uri_reiss.webp',
        hasVerifiedQuote: true
    },
    // ============ OTHER NOTABLE CHARACTERS ============
    {
        id: '56',
        name: 'Kiyomi Azumabito',
        gender: 'Female',
        arc: 'Marley',
        arcNumber: 8,
        affiliation: 'Civilians',
        species: 'Human',
        height: 'Average',
        status: 'Alive',
        quotes: {
            en: "The Azumabito clan has waited for this moment.",
            tr: "Azumabito klanı bu anı bekliyordu.",
            es: "El clan Azumabito ha esperado este momento."
        },
        image: '/images/kiyomi_azumabito.webp',
        hasVerifiedQuote: true
    },
    {
        id: '57',
        name: 'Darius Zackly',
        gender: 'Male',
        arc: 'Female Titan',
        arcNumber: 4,
        affiliation: 'Military Police',
        species: 'Human',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "This court will decide Eren Yeager's fate.",
            tr: "Bu mahkeme Eren Yeager'ın kaderini belirleyecek.",
            es: "Este tribunal decidirá el destino de Eren Yeager."
        },
        image: '/images/darius_zackly.webp',
        hasVerifiedQuote: true
    },
    {
        id: '58',
        name: 'Gelgar',
        gender: 'Male',
        arc: 'Clash of Titans',
        arcNumber: 5,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "There's no booze left... THIS IS THE WORST!",
            tr: "İçki kalmamış... BU EN KÖTÜSÜ!",
            es: "No queda alcohol... ¡ESTO ES LO PEOR!"
        },
        image: '/images/gelgar.webp',
        hasVerifiedQuote: true
    },
    {
        id: '59',
        name: 'Ian Dietrich',
        gender: 'Male',
        arc: 'Trost',
        arcNumber: 3,
        affiliation: 'Garrison',
        species: 'Human',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "Protect the boy who can change everything!",
            tr: "Her şeyi değiştirebilecek çocuğu koruyun!",
            es: "¡Protejan al chico que puede cambiarlo todo!"
        },
        image: '/images/ian_dietrich.webp',
        hasVerifiedQuote: true
    },
    {
        id: '60',
        name: 'Louise',
        gender: 'Female',
        arc: 'War for Paradis',
        arcNumber: 9,
        affiliation: 'Yeagerists',
        species: 'Human',
        height: 'Short',
        status: 'Deceased',
        quotes: {
            en: "Mikasa, you're my hero.",
            tr: "Mikasa, sen benim kahramanımsın.",
            es: "Mikasa, eres mi heroína."
        },
        image: '/images/louise.webp',
        hasVerifiedQuote: true
    },
    // ============ ADDITIONAL CHARACTERS ============
    {
        id: '61',
        name: 'Flegel Reeves',
        gender: 'Male',
        arc: 'Uprising',
        arcNumber: 6,
        affiliation: 'Civilians',
        species: 'Human',
        height: 'Short',
        status: 'Alive',
        quotes: {
            en: "Starting from today... I, Flegel Reeves, am the new boss.",
            tr: "Bugunden itibaren... ben, Flegel Reeves, yeni patronum.",
            es: "A partir de hoy... yo, Flegel Reeves, soy el nuevo jefe."
        },
        image: '/images/flegel_reeves.webp',
        hasVerifiedQuote: true
    },
    {
        id: '62',
        name: 'Nick',
        gender: 'Male',
        arc: 'Female Titan',
        arcNumber: 4,
        affiliation: 'Civilians',
        species: 'Human',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "You have every right to be angry. But we did not stay silent out of malice! I do not cling to my own life as if it is something precious! I will prove that to you!",
            tr: "Ofkeli olmakta tamamen haklisin. Ama kotulukten dolayi sessiz kalmadik! Kendi hayatima degerli bir sey gibi sarilmiyorum! Bunu sana kanitlayacagim!",
            es: "Tienes todo el derecho a estar enojado. Pero no guardamos silencio por malicia. No me aferro a mi vida como si fuera algo precioso. Te lo demostrare."
        },
        image: '/images/nick.webp',
        hasVerifiedQuote: true
    },
    {
        id: '63',
        name: 'Mitabi Jarnach',
        gender: 'Male',
        arc: 'Trost',
        arcNumber: 3,
        affiliation: 'Garrison',
        species: 'Human',
        height: 'Tall',
        status: 'Deceased',
        quotes: {
            en: "...",
            tr: "...",
            es: "..."
        },
        image: '/images/mitabi_jarnach.webp',
        hasVerifiedQuote: false
    },
    {
        id: '64',
        name: 'Dimo Reeves',
        gender: 'Male',
        arc: 'Uprising',
        arcNumber: 6,
        affiliation: 'Civilians',
        species: 'Human',
        height: 'Short',
        status: 'Deceased',
        quotes: {
            en: "...",
            tr: "...",
            es: "..."
        },
        image: '/images/dimo_reeves.webp',
        hasVerifiedQuote: false
    },
    {
        id: '65',
        name: 'Daz',
        gender: 'Male',
        arc: 'Training',
        arcNumber: 2,
        affiliation: 'Yeagerists',
        species: 'Human',
        height: 'Average',
        status: 'Deceased',
        quotes: {
            en: "I can't fight the Titans. My buddies were eaten right in front of me. They were eaten alive... and I didn't feel anything. No sadness or hate. I was just incredibly grateful that it wasn't me.",
            tr: "Titanlarla savasamam. Arkadaslarim gozlerimin onunde yenildi. Canli canli yenildiler... ve ben hicbir sey hissetmedim. Ne uzuntu ne de nefret. Sadece bunun ben olmadigima cok sukrettim.",
            es: "No puedo luchar contra los Titanes. Mis amigos fueron devorados justo frente a mi. Se los comieron vivos... y no senti nada. Ni tristeza ni odio. Solo estaba muy agradecido de que no fuera yo."
        },
        image: '/images/daz.webp',
        hasVerifiedQuote: true
    },
    {
        id: '66',
        name: 'Ilse Langnar',
        gender: 'Female',
        arc: 'Female Titan',
        arcNumber: 4,
        affiliation: 'Scout Regiment',
        species: 'Human',
        height: 'Short',
        status: 'Deceased',
        quotes: {
            en: "I don't believe it. For the first time in human history... I communicated with a Titan.",
            tr: "Inanamiyorum. Insanlik tarihinde ilk kez... bir Titan ile iletisim kurdum.",
            es: "No lo puedo creer. Por primera vez en la historia de la humanidad... me comunique con un Titan."
        },
        image: '/images/ilse_langnar.webp',
        hasVerifiedQuote: true
    },
    {
        id: '67',
        name: 'Djel Sannes',
        gender: 'Male',
        arc: 'Uprising',
        arcNumber: 6,
        affiliation: 'Military Police',
        species: 'Human',
        height: 'Tall',
        status: 'Alive',
        quotes: {
            en: "I believe in the security of the Walls and the king. Our actions weren't misguided... or so I thought. So this is how much it hurts. Just torture me to death. It's all I ever did with my blood-stained life.",
            tr: "Duvarlarin guvenligine ve krala inaniyorum. Eylemlerimizin yanlis olmadigina inandim... en azindan oyle saniyordum. Demek aci bu kadar buyukmus. Beni iskenceyle oldurun. Kanli hayatim boyunca yaptigim tek sey buydu.",
            es: "Creo en la seguridad de los muros y en el rey. Nuestras acciones no estaban equivocadas... o eso creia. Asi que asi de grande es este dolor. Torturenme hasta la muerte. Es todo lo que hice en mi vida manchada de sangre."
        },
        image: '/images/djel_sannes.webp',
        hasVerifiedQuote: true
    }
];

// Helper function to get seeded random number
export function seededRandom(seed: number): number {
    const x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
}

// Get day number since epoch (for daily character selection)
export function getDayNumber(): number {
    const now = new Date();
    const start = new Date(2024, 0, 1); // January 1, 2024
    const diff = now.getTime() - start.getTime();
    return Math.floor(diff / (1000 * 60 * 60 * 24));
}

// Get daily character based on game mode
export function getDailyCharacter(mode: string): AOTCharacter {
    const dayNumber = getDayNumber();
    const seed = dayNumber + (mode === 'Quote' ? 1000 : mode === 'Image' ? 2000 : 0);

    // Filter characters based on mode
    let eligibleCharacters = AOT_CHARACTERS;
    if (mode === 'Quote') {
        eligibleCharacters = AOT_CHARACTERS.filter(c => c.hasVerifiedQuote);
    }

    const index = Math.floor(seededRandom(seed) * eligibleCharacters.length);
    return eligibleCharacters[index];
}

// Get yesterday's character
export function getYesterdayCharacter(mode: string): AOTCharacter | null {
    const today = getDayNumber();
    if (today === 0) return null;

    const yesterdaySeed = (today - 1) + (mode === 'Quote' ? 1000 : mode === 'Image' ? 2000 : 0);

    let eligibleCharacters = AOT_CHARACTERS;
    if (mode === 'Quote') {
        eligibleCharacters = AOT_CHARACTERS.filter(c => c.hasVerifiedQuote);
    }

    const index = Math.floor(seededRandom(yesterdaySeed) * eligibleCharacters.length);
    return eligibleCharacters[index];
}

// Arc order for comparison
export const ARC_ORDER: Record<string, number> = {
    'Fall of Shiganshina': 1,
    'Training': 2,
    'Trost': 3,
    'Female Titan': 4,
    'Clash of Titans': 5,
    'Uprising': 6,
    'Return to Shiganshina': 7,
    'Marley': 8,
    'War for Paradis': 9
};

// Height order for comparison
export const HEIGHT_ORDER: Record<string, number> = {
    'Short': 1,
    'Average': 2,
    'Tall': 3
};
